const store = {
  guestFillOutDetails: {
    token: "",
    clientDetails: {}
  },
  consolidatedRequest: {},
  application: {},
  rawSchema: {}
};
export default store;